import "babel-polyfill";
import "unorm";
// IE11 native remove() polyfill
if (!("remove" in Element.prototype)) {
  Element.prototype["remove"] = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}
// IE11 matches polyfill
if (!Element.prototype.matches) {
  // определяем свойство
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector;
}
// IE11 closest polyfill
if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;
    while (node) {
      if (node.matches(css)) return node;
      else node = node.parentElement;
    }
    return null;
  };
}
import Vue from "vue";
import { store } from "./store/store";
import transliterate from "cyrillic-to-translit-js";
import OutsideClick from "./directives/outside-click";
import Notify from "./components/popup/Notify/index";
import VueMeta from "vue-meta";

const VueInputMask = require("vue-inputmask").default;

Vue.use(VueMeta);
Vue.use(Notify);
Vue.use(VueInputMask);
Vue.use(transliterate);

import router from "./router";

import VueYandexMetrika from "vue-yandex-metrika";
Vue.use(VueYandexMetrika, {
  id: window.__env.settings.yandexMetrika,
  router: router,
  env: process.env.NODE_ENV,
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  },
  scriptSrc: "https://mc.yandex.ru/metrika/tag.js",
});

import fullscreen from "vue-fullscreen";
Vue.use(fullscreen);

import VueLazyload from "vue-lazyload";
import loaderGif from "./assets/preloader.gif";
Vue.use(VueLazyload, {
  loading: loaderGif,
});

import Echo from "laravel-echo";
window.io = require("socket.io-client");
//#################### Start Echo Server ####################################
let broadcastName = "socket.io";
if (window.__env.settings.mode === "mz") {
  broadcastName = "null"
}

if (typeof io !== "undefined") {
  window.Echo = new Echo({
    broadcaster: broadcastName,
    host: window.__env.api.websocket_url,
    auth: { headers: { Authorization: " " } },
    json: { "socket.io'": { pingTimeout: 60000 } },
  });
}

import http from "./http";
import config from "./auth";

import moment from "moment";
moment.locale("ru");

Vue.filter("dateFormat", (dateString, formatString = "DD.MM.Y") => {
  return moment(String(dateString)).format(formatString);
});
Vue.filter("dateCheckOlderThan", (dateString, daysCount = 0) => {
  return moment(String(dateString)).diff(moment(), "days") > -daysCount;
});

Vue.filter("translateUrl", (string) => {
  let temporalDivElement = document.createElement("div");
  temporalDivElement.innerHTML = string;
  let stripString =
    temporalDivElement.textContent || temporalDivElement.innerText || "";
  stripString = stripString.replace(/[.,/]/g, "_");
  return transliterate().transform(stripString, "_");
});

Vue.filter("getDays", (days) => {
  if (days < 0) {
    return "Истёк";
  }
  let prefix = 0 < days && days < 1 ? "<" : "";
  days = Math.ceil(days);
  let postfix = " дней";
  if (4 < days && days < 21) {
    return days + postfix;
  }
  if (days % 10 === 1) {
    postfix = " день";
  } else if (1 < days % 10 && days % 10 < 5) {
    postfix = " дня";
  }
  return prefix + days + postfix;
});

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.router.beforeEach(function (to, from, next) {
  if (
    Vue.auth.check() &&
    Vue.auth.user().demo === 1 &&
    to.name !== "profile-getdemo"
  ) {
    next({
      name: "profile-getdemo",
    });
  } else if(to.name === "medx-auth") {
    window.document.body.classList.add('short-view');
    next();
  } else next();
});

Vue.directive("outside-click", OutsideClick);

import App from "./App.vue";
Vue.config.productionTip = false;

const initialUrls = ["/site"];
import pluginFactory from "@/plugins/PluginFactory";
import Domain from "@/plugins/domain";
pluginFactory(Vue.axios, initialUrls).then((response) => {
  Vue.use(Domain, response["/site"]);
  const siteData = response["/site"].data.data;

  if ([10,12].includes(siteData.site.id)) {
    siteData.site.loginFormHeaderHtml = '<p>Чтобы воспользоваться всеми преимуществами системы, такими как добавление материалов в избранное, сохранение истории просмотров и т.д., необходимо использовать систему в авторизованном режиме.</p>';
    siteData.site.registrationPopupText = 'Чтобы воспользоваться всеми преимуществами системы, такими как добавление материалов в избранное, сохранение истории просмотров и т.д., необходимо пройти процедуру регистрации и использовать систему в авторизованном режиме.';
    siteData.site.registrationPopupAllowHide = true;
  } else {
    siteData.site.loginFormHeaderHtml = null;
    siteData.site.registrationPopupText = 'АЛГОМ - это уникальная справочная система на основе доказательной медицины. Содержит простые и понятные протоколы диагностики и лечения всех заболеваний. Зарегистрируйтесь для доступа к системе (3 дня бесплатно).';
    siteData.site.registrationPopupAllowHide = false;
  }
  store.commit("setSite", response["/site"].data.data);
  // Vue.use(Domain, response["/site"]);
  const app = new Vue({
    store,
    http: http,
    config: config,
    router: router,
    render: (h) => h(App),
  }).$mount("#app");
  store.$app = app;
}).catch(() => {
  if (window.location.pathname !== "/500") {
    window.location.href = "/500"
  }
  const app = new Vue({
    router: router,
    render: (h) => h(App),
  }).$mount("#app");
});


